import React, { useState } from 'react';
import { Button, Table } from '../../../UiKit';
import Shimmer from 'sushiweb/Shimmer';
import { EmptyState } from '../../commons';
import { InvalidSearchImg } from '../../../images/images';
import { getTableData } from './utils';
import { useQueryCall } from '../../../api/react-client';
import { lifelineEndPoints } from '../../../api/end-points';

export const LinkedUsers = ({ userId = null }) => {
  const [offset, setOffset] = useState(0);
  const linkedUserEndPoint = `${lifelineEndPoints?.GET_LINKED_USER}?user_id=${userId}&offset=${offset}`;
  const queryKey = ['getLinkedUsers', userId, offset];
  const { data, isLoading } = useQueryCall({}, linkedUserEndPoint, queryKey);

  if (isLoading || !data) {
    return <Shimmer height='100%' width='100%' />;
  }

  const { comment, has_more, linked_user_ids } = data;

  if (!linked_user_ids?.length) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={data?.message || 'No Users available!'}
        isPop={true}
      />
    );
  }

  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        height: 100%;
        gap: 10px;
      `}
      className='modalContent'
    >
      <p
        css={`
          font-size: 16px;
          font-weight: 500;
        `}
      >
        {comment}
      </p>
      <Table tableData={getTableData(linked_user_ids)} />

      {/* {has_more ? ( */}
      <div
        css={`
          margin-top: auto;
          justify-content: center;
          display: flex;
          gap: 10px;
        `}
      >
        <Button
          isDisabled={offset === 0 || isLoading}
          title='Previous Page'
          onClick={() => {
            if (offset > 0) {
              setOffset((s) => (s - 5 < 0 ? 0 : s - 5));
            }
          }}
        />
        <Button
          isDisabled={isLoading || !has_more}
          title='Next Page'
          onClick={() => {
            if (has_more) {
              setOffset((s) => s + 5);
            }
          }}
        />
      </div>
      {/* ) : null} */}
    </div>
  );
};
